import * as ex from 'excalibur';
import { PlayerUnit } from './playerUnit';

// Player-controlled Merk
export class PlayerMerk extends PlayerUnit {
  constructor(options: any) {
    super({
      gridX: options.gridX,
      gridY: options.gridY,
      type: 'merk',
      name: 'Merk',
      color: ex.Color.Blue,
      initiative: options.initiative,
      health: 30,
      maxHealth: 30,
      moveRange: 2,
      attackRange: 1,
      abilities: ['straight_line_attack'],
      grid: options.grid
    });

    // Set the emoji for this unit type
    this.setEmoji("⚔️"); // Sword for warrior/fighter type
  }
}